export default __webpack_public_path__ + "static/media/history.1e0eff7b.svg";